import { FooterProps } from "@app/components/Pdf";
import { useUser } from "@app/pages/settings/useUser";
import { usePlanTypes } from "@app/hooks/usePlanTypes";
import { useFirm } from "@app/pages/settings/useFirm";
import { useSearchParams } from "react-router-dom";
import { usePlanTypeId } from "@app/hooks/usePlanId";
import { useClientName } from "@app/hooks/useClientName";
import { usePublishPlanHouseholdAllocation } from "../publishPlanDialog/usePublishPlanHouseholdAllocation";
import { TitleActionPdfPage } from "./TitleActionPdfPage";
import { GoalsActionPdfPage } from "./GoalsActionPdfPage";
import { RiskBarometerActionPdfPage } from "./RiskBarometerActionPdfPage";
import { RiskReportsActionPdfPage } from "./RiskReportsActionPdfPage";
import { DisclosuresActionPdfPage } from "./DisclosuresActionPdfPage";
import { HouseholdAllocationActionPdfPage } from "./HouseholdAllocationActionPdfPage";
import { ActionPlanActionPdfPage } from "./ActionPlanActionPdfPage";
import { usePublishPlanActionPlan } from "../publishPlanDialog/usePublishPlanActionPlan";
import { usePlanSummary } from "@app/features/planSummary/usePlanSummary";
import { usePlanResults } from "@app/features/planResults/usePlanResults";
import { useDisclosures } from "@app/hooks/useDisclosures";
import { CarPdfViewer } from "@app/components/PdfViewer";
import { CarPdfDocument } from "@app/components/PdfDocument";

export const ActionReport = () => {
  const [searchParams] = useSearchParams();
  const client = useClientName();
  const user = useUser();
  const firm = useFirm();

  const disclosures = useDisclosures();

  const planTypes = usePlanTypes();
  const planTypeId = usePlanTypeId();
  const portfolioLabel = planTypes.getPlanTypeLabel(planTypeId);

  const planSummary = usePlanSummary();
  const publishPlanHouseholdAllocation = usePublishPlanHouseholdAllocation();
  const planResults = usePlanResults();
  const publishPlanActionPlan = usePublishPlanActionPlan();

  const isLoading =
    disclosures.isLoading ||
    client.isLoading ||
    user.isLoading ||
    firm.isLoading ||
    planSummary.isLoading ||
    planResults.isLoading ||
    publishPlanActionPlan.isLoading ||
    planTypes.isLoading;

  const isDraft = searchParams.get("draft") === "true";
  const title = `Action Plan for ${client.clientAndSpouseFullName}`;

  const footerProps = (): FooterProps => ({
    isDraft,
    advisorCompanyName: firm.firm.name ?? "",
    clientName: client.clientFullName,
  });

  return (
    <CarPdfViewer isLoading={isLoading}>
      <CarPdfDocument title={title} author={user.userFullName}>
        <TitleActionPdfPage
          clientName={client.clientFullName}
          advisorName={user.userFullName}
          logo={firm.firm.logo ?? undefined}
          portfolioLabel={portfolioLabel}
          footerProps={footerProps()}
        />
        <GoalsActionPdfPage
          goals={planSummary.goals}
          donuts={planResults.donuts}
          footerProps={footerProps()}
        />
        <HouseholdAllocationActionPdfPage
          publishPlanHouseholdAllocation={publishPlanHouseholdAllocation}
          footerProps={footerProps()}
        />
        <RiskBarometerActionPdfPage
          planResults={planResults}
          footerProps={footerProps()}
        />
        <RiskReportsActionPdfPage
          planResults={planResults}
          footerProps={footerProps()}
        />
        <ActionPlanActionPdfPage
          publishPlanActionPlan={publishPlanActionPlan}
          footerProps={footerProps()}
        />
        <DisclosuresActionPdfPage
          disclosures={disclosures}
          footerProps={footerProps()}
        />
      </CarPdfDocument>
    </CarPdfViewer>
  );
};
